<template>
    <div class="container d-flex justify-content-center align-items-center mt-5">
        <div class="upload-card shadow-lg p-5">
            <div v-if="erro" class="text-center">
                <h3 class="text-danger">Ops! Link inválido ou expirado.</h3>
                <p>Verifique se o endereço está correto ou peça uma nova solicitação.</p>
            </div>

            <div v-else-if="carregando" class="text-center">
                <p>Carregando solicitação...</p>
            </div>

            <div v-else-if="!uploadConcluido">
                <h2 class="mb-3 text-center">Envio de {{ processo.nmModelo }}</h2>
                <p class="text-center text-muted mb-4">
                    Você foi convidado por "{{usuario.nmUsuario}}" a enviar um documento referente ao processo nomeado de <strong>{{processo.dsNome}}</strong>. Esse envio é seguro e será vinculado diretamente ao processo correspondente.
                </p>

                <div class="mb-3">
                    <div class="text-center mb-3">
                        <strong>Por favor encaminhe o arquivo do {{ processo.nmModelo }} referente ao processo abaixo:</strong>
                    </div>
                    <p v-if="processo.nrProcesso">
                        <strong>Número:</strong> {{ processo.cdProcesso }} <br />
                    </p>
                    <p v-if="processo.dsNome">
                        <strong>Nome:</strong> {{ processo.dsNome }} <br />
                    </p>
                    <p v-if="processo.dsProcesso">
                        <strong>Descrição:</strong> {{ processo.dsProcesso }}
                    </p>
                    <p v-if="processo.dsNomeLegislacao">
                        <strong>Legislação:</strong> {{processo.dsNomeLegislacao}} <br />
                    </p>
                </div>

                <hr />

                <p class="mb-2 text-center">Selecione um arquivo para envio:</p>
                <AvisoUploadDocumentos />
                <div class="upload-center">
                    <InputUploadS3 :reset="resetUpload"
                                   :labelText="'Selecionar Arquivo'"
                                   @onSave="setUploadFile"
                                   @onDelete="deleteUploadFile"
                                   :destino="'ProcessoArtefato'"
                                   :dsHash="hash"
                                   :maxFileSize="800"
                                   :multiple="false"
                                   :whoFiles="'.pdf,.doc,.docx'"
                                   :id="'upload_solicitacao'" />
                </div>
                <p class="text-center mb-3">(Formatos aceitos: <strong>.pdf ou .docx</strong> - Tamanho máximo: 800MB)</p>

                <button class="btn btn-primary w-100 mt-4" @click="enviarUpload">
                    Enviar Documento
                </button>
            </div>
            <div v-else class="text-center">
                <h3 class="text-success">Arquivo enviado com sucesso!</h3>
                <p class="mt-3">Sua solicitação foi concluída. Este link não pode ser reutilizado.</p>
            </div>
        </div>
    </div>
</template>



<script>
    import axios from 'axios'
    import InputUploadS3 from '@/components/Input_Upload_s3Centralizado'
    import AvisoUploadDocumentos from '@/components/AvisoUploadDocumentos'
    import { urlApi, avisoErro, avisoToast } from '@/config/global'

    export default {
        name: 'SolicitacaoEnvio',
        components: { InputUploadS3, AvisoUploadDocumentos },
        data() {
            return {
                carregando: true,
                erro: false,
                idProcesso: null,
                idProcessoModeloArtefato: null,
                dsLogin: null,
                processo: [],
                usuario: null,
                urlArquivoS3: null,
                fileName: null,
                resetUpload: false,
                hash: null,
                uploadConcluido: false,
            }
        },
        methods: {
            async carregarSolicitacao(hash) {
                try {
                    const response = await axios.get(`${urlApi}/ProcessoArtefatoSolicitacaoEnvio/GetByHash`, {
                        params: { hash }
                    });

                    if (response.data.success) {
                        this.processo = response.data.data.processo;
                        this.usuario = response.data.data.usuario;
                        this.dsLogin = response.data.data.dsLoginDestino;
                        this.idProcesso = response.data.data.idProcesso;
                        this.idProcessoModeloArtefato = response.data.data.idProcessoModeloArtefato;
                    } else {
                        this.erro = true;
                        this.msgErro = response.data.msg || "Solicitação inválida.";
                    }
                } catch (err) {
                    this.erro = true;
                    this.msgErro = err.response?.data?.msg || "Erro ao carregar a solicitação.";
                } finally {
                    this.carregando = false;
                }
            },

            setUploadFile(arquivo) {
                this.urlArquivoS3 = arquivo.key;
                this.fileName = arquivo.fileName;
            },

            deleteUploadFile() {
                this.urlArquivoS3 = null;
                this.fileName = null;
            },

            async enviarUpload() {
                if (!this.urlArquivoS3) {
                    avisoErro("Nenhum arquivo selecionado.");
                    return;
                }

                try {
                    const res = await axios.post(`${urlApi}/ProcessoArtefato/UploadPublico`, {
                        idProcesso: this.idProcesso,
                        idProcessoModeloArtefato: this.idProcessoModeloArtefato,
                        key: this.urlArquivoS3,
                        fileName: this.fileName,
                        dsLogin: this.dsLogin
                    });

                    if (res.data.success) {
                        avisoToast("Arquivo enviado com sucesso!");
                        await axios.post(`${urlApi}/ProcessoArtefatoSolicitacaoEnvio/MarcarRespondido`, {
                            dsHash: this.hash, 
                            dsLoginDestino: this.dsLogin 
                        });
                        this.uploadConcluido = true;
                        this.deleteUploadFile();
                        this.resetUpload = !this.resetUpload;

                    } else {
                        avisoErro(res.data.msg || "Não foi possível enviar o arquivo.");
                    }
                } catch (err) {
                    avisoErro("Falha ao enviar arquivo.");
                }
            }
        },
        mounted() {
            this.hash = new URLSearchParams(window.location.search).get('hash');
            if (!this.hash) {
                this.erro = true;
                this.carregando = false;
                return;
            }

            this.carregarSolicitacao(this.hash);
        }
    }
</script>


<style scoped>
    .container {
        min-height: 80vh;
    }

    .upload-card {
        background-color: #fff;
        border-radius: 16px;
        max-width: 700px;
        width: 100%;
    }

    .btn-primary {
        background-color: #0051ad;
        border: none;
        font-weight: bold;
    }

    .text-muted {
        font-size: 0.95rem;
        color: #6c757d;
    }

    .upload-center {
        display: flex;
        justify-content: right;
        margin-right: 20px
    }

        .upload-center ::v-deep .row {
            justify-content: center !important;
        }

        .upload-center ::v-deep .col-6,
        .upload-center ::v-deep .col {
            flex: 0 0 auto !important;
            max-width: 400px;
            width: 100%;

        }

        .upload-center ::v-deep .input-group {
            width: 100%;
        }

</style>

